import React, { useState } from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const LoginModal = ({ isOpen, onClose }) => {
	const { login } = useAuth();
	const navigate = useNavigate();
	const [loginForm, setLoginForm] = useState({ email: "", password: "" });
	const [error, setError] = useState("");

	if (!isOpen) return null;

	const handleLogin = async () => {
		setError("");
		const success = await login(loginForm.email, loginForm.password);
		if (success) {
			setLoginForm({ email: "", password: "" });
			onClose();
			navigate("/dashboard");
		} else {
			setError("Invalid email or password");
		}
	};

	return (
		<div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50">
			<div className="bg-gray-900 border border-gray-700 rounded-xl p-8 max-w-md w-full mx-4">
				<div className="flex justify-between items-center mb-6">
					<h3 className="text-2xl font-bold text-white">Login</h3>
					<button
						onClick={onClose}
						className="text-gray-400 hover:text-white transition-colors"
					>
						<X className="w-6 h-6" />
					</button>
				</div>
				<div className="space-y-4">
					<div>
						<label className="block text-sm font-medium mb-2 text-gray-300">
							Email
						</label>
						<input
							type="email"
							value={loginForm.email}
							onChange={(e) =>
								setLoginForm({ ...loginForm, email: e.target.value })
							}
							className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white placeholder-gray-400"
							placeholder="Enter your email"
						/>
					</div>
					<div>
						<label className="block text-sm font-medium mb-2 text-gray-300">
							Password
						</label>
						<input
							type="password"
							value={loginForm.password}
							onChange={(e) =>
								setLoginForm({ ...loginForm, password: e.target.value })
							}
							onKeyPress={(e) => e.key === "Enter" && handleLogin()}
							className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white placeholder-gray-400"
							placeholder="Enter your password"
						/>
					</div>
					{error && (
						<div className="text-sm text-red-400 bg-red-900/20 p-3 rounded-lg border border-red-800">
							{error}
						</div>
					)}
					{/* <div className="text-sm text-gray-400 bg-gray-800 p-4 rounded-lg border border-gray-700">
						<p className="font-medium mb-2 text-gray-300">Demo credentials:</p>
						<p>Admin: admin@jamesdixon.com / admin</p>
						<p>User: any email / any password</p>
					</div> */}
					<button
						onClick={handleLogin}
						className="w-full bg-gradient-to-r from-orange-700 to-orange-500 text-white py-3 rounded-lg hover:from-orange-800 hover:to-orange-600 transition-all duration-200 font-medium"
					>
						Login
					</button>
				</div>
			</div>
		</div>
	);
};

export default LoginModal;
